import {useNavigate} from 'react-router-dom';
import {Button} from '@mui/material';

import {CardBox} from '@shared/components';
import {Header} from '@widgets/common';

import {COLOR__WHITE} from '@/theme/colors';

export const EditMarketplaceItemPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header title="Edit item" mb={1} />

      <CardBox bgcolor={COLOR__WHITE}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Back
        </Button>
      </CardBox>
    </>
  );
};
